import { SVGSVGInstance } from "./shared/instances/SVGSVGInstance.js";
import { SVGCircleInstance } from "./shared/instances/SVGCircleInstance.js";
import { SVGGroupInstance } from "./shared/instances/SVGGroupInstance.js";
import { SVGLineInstance } from "./shared/instances/SVGLineInstance.js";
import { SVGPathInstance } from "./shared/instances/SVGPathInstance.js";
import { SVGRectInstance } from "./shared/instances/SVGRectInstance.js";
import { SVGTextInstance } from "./shared/instances/SVGTextInstance.js";
import { SVGTSpanInstance } from "./shared/instances/SVGTSpanInstance.js";
import { SVG } from "./shared/exports/svg.js";
export * from "./shared/exports/calc.js";
export { SVGSVGInstance, SVGCircleInstance, SVGGroupInstance, SVGLineInstance, SVGPathInstance, SVGRectInstance, SVGTextInstance, SVGTSpanInstance, SVG };
export default SVG;
//# sourceMappingURL=index.js.map